import { render } from "./modalXmlDetallado.vue?vue&type=template&id=f3f77a36&scoped=true"
import script from "./modalXmlDetallado.vue?vue&type=script&lang=js"
export * from "./modalXmlDetallado.vue?vue&type=script&lang=js"

import "./modalXmlDetallado.vue?vue&type=style&index=0&id=f3f77a36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f77a36"]])

export default __exports__